// _gcl_aw / _gcl_gb hold GCL.<timestamp>.<click id>[.<suffix>]; the click id is always the third segment
export function parseGclCookie(value: string | undefined): string | undefined {
  return value?.match(/^GCL\.\d+\.([^.]+)/)?.[1];
}

// _gcl_ag holds e.g. 2.1.k<gbraid>$i<timestamp>$b<suffix>
export function parseGclAgCookie(value: string | undefined): string | undefined {
  return value?.match(/(?:^|\.)k([^$.]+)\$i\d+(?:\$|$)/)?.[1];
}
